// ./components/Shared/Dialog.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';

export function Dialog({ trigger, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      setIsOpen(true);
    }
  };
  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen(true)}
        onKeyDown={handleKeyDown}
        className="inline-block"
        aria-label="Open dialog"
      >
        {trigger}
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-lg relative">
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              aria-label="Close dialog"
            >
              ✕
            </button>
            {children}
          </div>
        </div>
      )}
    </>
  );
}

Dialog.propTypes = {
  trigger: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};
export function DialogTrigger({ asChild, children }) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => children.props.onClick()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          children.props.onClick();
        }
      }}
      className="inline-block"
      aria-label="Dialog trigger"
    >
      {asChild ? children : <button type="button">{children}</button>}
    </div>
  );
}

DialogTrigger.propTypes = {
  asChild: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export function DialogContent({ children }) {
  return <div className="p-6">{children}</div>;
}

DialogContent.propTypes = {
  children: PropTypes.node.isRequired,
};
DialogTrigger.defaultProps = {
  asChild: false,
};
